export default __webpack_public_path__ + "static/media/tick.e6e760d5.svg";